const hugeFileSizeChecker = (fileSize: number) => {
  if (fileSize / 1000000 > 5) {
    return true;
  } else if (fileSize && fileSize / 1000000 <= 5) {
    return false;
  }
};

export {hugeFileSizeChecker};
